import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import styles from './AutocompleteForm.module.scss'

const propTypes = {
  className: PropTypes.string
}

const AutocomleteForm = ({ className, ...restProps }) => (
  <form className={classnames(styles.root, className)} autoComplete='off' {...restProps} />
)

AutocomleteForm.propTypes = propTypes

export default AutocomleteForm
